<template>
  <div v-wechat-title="titleTop" class="allBack">
    <!-- -->
    <template v-if="!homepage">
      <van-swipe class="imgBodys">
        <van-swipe-item v-for="(image, index) in images" v-show="loadImageFinish" :key="index">
          <van-image fit="contain" height="100%" width="100%" :src="image" style="display: block;vertical-align: middle;" @load="onImgLoadFinish" />
        </van-swipe-item>
      </van-swipe>
      <div class="imgDownStr">长按图片保存 右划查看更多</div>
    </template>
    <template v-if=" homepage">
      <img src="https://res.diveboss.net/activity/burning2024/homeback1.png">

      <img src="https://res.diveboss.net/activity/burning2024/homelogo.png" class="homelogo">

      <img src="https://res.diveboss.net/activity/burning2024/hometitle3.png" class="hometitle1">
      <img src="https://res.diveboss.net/activity/burning2024/homebutton1.png" class="homebutton" @click="onBuild">
      <div class="inputRect">
        <van-field v-model="name" placeholder="输入你的火人节名字" input-align="left" maxlength="30" class="inputLine" />
      </div>
       <div class="inputRect2">
        <van-field v-model="connect" placeholder="输入你的联系方式" input-align="left" maxlength="300" class="inputLine" />
      </div>
    </template>
  </div>
</template>
<script>
import { Button, Field, Image, Swipe, SwipeItem, Toast } from 'vant'
import { MyNotify, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import { GetServiceUrlBase } from '@/utils/request'
export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Image.name]: Image,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem
  },
  data() {
    return {
      titleTop: 'Burning Man 2025',
      name: '',
      connect:'',
      homepage: true,
      loadImageFinish: false,
      imgUrl: undefined,
      images: []
    }
  },
  mounted() {
    // 挂载成功后给pop事件绑定一个方法
    // 如果支持 popstate （一般移动端都支持）
    if (window.history && window.history.pushState) {
      // 往历史记录里面添加一条新的当前页面的url
      history.pushState(null, null, document.URL)
      // 给 popstate 绑定一个方法用来监听页面返回
      window.addEventListener('popstate', this.back, false) // false阻止默认事件
    }
  },

  // 组件销毁后清除事件
  destroyed() {
    window.removeEventListener('popstate', this.back, false) // false阻止默认事件
  },
  created() {

  },
  methods: {
    MyNotify,
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    back() {
      console.log('监听到了')
      window.location.reload()
    },
    onBuild() {
      if (!this.name) {
        MyNotify('error', '请输入你的火人节名字')
        return
      }
      var url = GetServiceUrlBase() + '/userAPI/ThirdActivitie/GetBurningImage?name=' + encodeURIComponent(this.name)+'&connect='+encodeURIComponent(this.connect)
      console.log('获取图片中:' + url)
      // this.imgUrl = url
      this.images = [
        url + '&id=1',
        url + '&id=2',
        url + '&id=3',
        url + '&id=4',
        url + '&id=5',
        url + '&id=6',
        url + '&id=7',
        url + '&id=8',
        url + '&id=9',
        url + '&id=10',
        url + '&id=11',
      ]
      this.homepage = false
      Toast.loading({
        message: 'China Village',
        forbidClick: true
      })
      console.log('this.img', this.images)
    },
    onImgLoadFinish() {
      console.log('onImgLoadFinish')
      this.loadImageFinish = true
      Toast.clear()
    }
  }
}
</script>
<style scoped>
::v-deep .van-field__control::-webkit-input-placeholder {
  color: #fff;
}

::v-deep .van-field__control {
  color: #fff;
}

.allBack {
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #CCCCCC;
  min-height: 100vh;
  background-image: url('https://res.diveboss.net/activity/burning2023/homebackback.png');
  background-size: 100vw auto;
  background-repeat: repeat-y;
}

img {
  width: 100vw;
  display: block;
  vertical-align: middle;
}

.homelogo {
  position: fixed;
  left: 10vw;
  top: 88vh;
  width: 28vw;
}

.hometitle1 {
  position: fixed;
  left: 10vw;
  top: 50vw;
  width: 45vw;
}

.homebutton {
  position: fixed;
  left: 10vw;
  top: 95vw;
  width: 45vw;
}

.homelogo img {
  width: 100%;
}

.homebutton img {
  width: 100%;
}

.hometitle1 img {
  width: 100%;
}

.inputRect {
  position: fixed;
  left: 10vw;
  top: 71vw;
  height: 8vw;
  width: 44vw;
  background-color: transparent;
  border: 2px solid #fff;
}
.inputRect2 {
  position: fixed;
  left: 10vw;
  top: 81vw;
  height: 8vw;
  width: 44vw;
  background-color: transparent;
  border: 2px solid #fff;
}

.inputLine {
  background-color: transparent;
  line-height: 8vw;
  height: 8vw;
  padding: 0px 5px !important;
}

.buttonRect {
  position: absolute;
  left: 30vw;
  right: 30vw;
  top: 113vw;
  height: 10vw;
}

.imgBodys{
  height: 90vh;
  margin-top: 4vh;
}
.imgDownStr{
  text-align: center;
  color: #ccc;
  font-size: 0.8em;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 3em;
  line-height: 3em;
}
</style>

